module.exports = __webpack_public_path__ + "img/drink.be5030ca.webp";